export default [
  {
    path: '/ledger/:key?',
    name: 'ledgerIndex',
    component: () => import('@/views/ledger/LedgerIndex.vue'),
    meta: {},
  },
];
